import React from 'react';
import { Button } from 'react-bootstrap';
import { formatDate, formatTimeTo12Hour } from '../../../utils/utils';
import { GenericModal } from '../common/Modal/GenericModal';

export const SessionConfirmationModal = ({
  showConfirmationModal,
  isBookingInProgress,
  setShowConfirmationModal,
  handleCheckout,
  selectedSlot,
  subject, //previously subjects
  proficiencyLabels,
  optionalMessage,
  isReschedule = false // Add this prop
}) => {
  return (
    <GenericModal
      show={showConfirmationModal}
      handleClose={() => !isBookingInProgress && setShowConfirmationModal(false)}
      title={isReschedule ? 'Confirm Reschedule' : 'Confirm Booking'}
      footerActions={
        <>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmationModal(false)}
            disabled={isBookingInProgress}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className={`btn ${isReschedule ? 'btn-warning' : 'btn-primary'}`}
            onClick={handleCheckout}
            disabled={isBookingInProgress}
          >
            {isBookingInProgress 
              ? (isReschedule ? 'Rescheduling...' : 'Processing...') 
              : (isReschedule ? 'CONFIRM RESCHEDULE' : 'PROCEED TO PAYMENT')
            }
          </Button>
        </>
      }
    >
      {selectedSlot && (
        <div className="confirmation-details">
          <div className="mb-3">
            {/* <div className="border border-primary border-2 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
              <i className="bi bi-calendar-check text-primary fs-1"></i>
            </div> */}
            <h5>Booking Details:</h5>
          </div>

          <div className="card bg-light mb-4">
            <div className="card-body">
              <div className="d-flex align-items-start mb-3">
                <i className="bi bi-calendar-date text-primary me-3 fs-4"></i>
                <div>
                  <strong>Date & Time</strong>
                  <p className="mb-0">{formatDate(selectedSlot.date)}</p>
                  <p className="mb-0">{formatTimeTo12Hour(selectedSlot.startTime)} - {selectedSlot.duration} minutes</p>
                </div>
              </div>
              {!isReschedule && (
                <>
                  <div className="d-flex align-items-start mb-3">
                    <i className="bi bi-book text-primary me-3 fs-4"></i>
                    <div>
                      <strong>Subject</strong>
                      {/* <p className="mb-0">{subjects.find(s => s.id.toString() === selectedSlot.subjectId?.toString())?.name}</p> */}
                      <p className="mb-0">{subject}</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-start mb-3">
                    <i className="bi bi-graph-up-arrow text-primary me-3 fs-4"></i>
                    <div>
                      <strong>Language Proficiency</strong>
                      <p className="mb-0">{selectedSlot.proficiency}</p>
                    </div>
                  </div>
                </>
              )}

              {optionalMessage && (
                <div className="d-flex align-items-start">
                  <i className="bi bi-chat-left-text text-primary me-3 fs-4"></i>
                  <div>
                    <strong>Your Message</strong>
                    <p className="mb-0">{optionalMessage}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </GenericModal>
  );
};